import PreferredDealersReportBuilder from "@/model/builders/ffl-preferred-dealers-excel.mjs";
import moment from "moment";
import * as XLSX from 'xlsx-js-style';

export const formatMillisecondsToDate = (milliseconds: number) => {
    return moment(milliseconds).format('MM/DD/YYYY');
}
  
export const checkExpiryDate = (expiryDate: number) => {
    const currentDate = moment();
    const expiry = moment(expiryDate);
    return expiry.isAfter(currentDate);
}

export const exportXLSXFile = (data: any, generatedBy: string) => {
    try {
      // Current date and time
      const currentDateTime = moment().format("MM/DD/YYYY hh:mm A");
      const formattedString = `Generated: \n${currentDateTime} \n\nGenerated By: \n${generatedBy}`;

      // Define the header data
      const headerData = [
        [formattedString],
        [], // Empty row
      ];

      // Define the data for the worksheet
      let response = PreferredDealersReportBuilder.buildPreferredDealersReportList(data);

      // Combine header and data
      const combinedData = [...headerData, ...response];

      // Create worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(combinedData);

      // Define styles for the headers
      const headerStyle = {
        font: { bold: true }, // Bold font for headers
      };
      
      // Apply styles to the data headers (not the generated info)
      const range = XLSX.utils.decode_range(worksheet['!ref'] as string);
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const address = XLSX.utils.encode_cell({ c: C, r: headerData.length }); // Start from data headers
        if (!worksheet[address]) continue;
        worksheet[address].s = headerStyle;
      }

      // Set column widths based on the maximum length of data in each column
      const colWidths = response[0].map((_: any, colIdx: any) => {
        const maxLength = response.reduce(
          (max, row) => Math.max(max, row[colIdx] ? row[colIdx].toString().length : 0),
          0
        );
        return { wch: maxLength + 8 }; // Add padding for better appearance
      });

      worksheet['!cols'] = colWidths;
      worksheet['!rows'] = worksheet['!rows'] || [];
      const rowHeight = calculateRowHeight(formattedString);
      worksheet['!rows'][0] = rowHeight ? { hpx: rowHeight } : {};

      // Define style for wrapping text in the first column (Generated)
      const wrapTextStyle = {
        alignment: { wrapText: true },
      };

      // Apply wrap text style only to the first column (Generated field)
      const firstColRange = XLSX.utils.decode_range("A1:A1");
      for (let C = firstColRange.s.c; C <= firstColRange.e.c; ++C) {
        const address = XLSX.utils.encode_cell({ c: C, r: 0 });
        if (!worksheet[address]) continue;
        worksheet[address].s = wrapTextStyle;
      }

      // Create workbook
      const workbook = {
        Sheets: { data: worksheet },
        SheetNames: ["data"],
      };

      // Write the workbook to a file and trigger download
      const currentDate = new Date()
      const formattedDate = moment(currentDate).format('MM/DD/YYYY_HH_mm_ss')
      const filename = `Preferred_Dealers_Export_ ${formattedDate}.xlsx`;
      XLSX.writeFile(workbook, filename);
    } catch (e) {
      console.log(e);
    }
  };

  function calculateRowHeight(content: string) {
    const defaultRowHeight = 12; // Default row height in pixels
    const lineHeight = 1.76; // Line height factor
    const lines = content.split(' \n');
    const contentHeight = lines.length * lineHeight * defaultRowHeight; // Calculate content height
    return contentHeight;
  }